import { makeAutoObservable } from 'mobx';
import * as orderService from '@/services/order';

export class Order {
  shop = {};

  constructor() {
    makeAutoObservable(this);
  }

  getList(params) {
    return orderService.getList(params);
  }

  getDetail(params) {
    return orderService.getDetail(params);
  }

  getAddressList(params) {
    return orderService.getAddressList(params);
  }

  async shippingInfo(body) {
    return await orderService.shippingInfo(body);
  }

  async shipCompany(body) {
    return await orderService.shipCompany(body);
  }

  async ship(body) {
    return await orderService.ship(body);
  }

  async setAddress(body) {
    return await orderService.setAddress(body);
  }

  async restock(body) {
    return orderService.restock(body);
  }

  async getRestockList(body) {
    return orderService.getRestockList(body);
  }

  async restockShip(body) {
    return orderService.restockShip(body);
  }

  confirmRestockOrder(body) {
    return orderService.confirmRestockOrder(body);
  }
}

export const ORDER = 'order';
